import { Component } from '@angular/core';

@Component({
  selector: 'app-playground-initial',
  standalone: true,
  imports: [],
  templateUrl: './playground-initial.component.html',
  styleUrl: './playground-initial.component.scss'
})
export class PlaygroundInitialComponent {

}
